// Auto-generated from a snapshot of dbo.SYS_LookupList / dbo.SYS_LookupListGroup (TOPS-NZ-DB).
// Static offline copy of the Internal Description quick-choice option lists used by tops-web-nz.
export interface InternalDescriptionOption {
  name: string;
  parameter1?: string;
  parameter2?: string;
}

export const INTERNAL_DESCRIPTION_OPTIONS: Record<string, InternalDescriptionOption[]> = {
  'AdditionalGarageConfiguration': [
    { name: 'Integrated' },
    { name: 'Detached' },
    { name: 'Attached' },
  ],
  'AdditionalGarageFixturesAndFittings': [
    { name: 'internal access' },
    { name: 'sectional door' },
    { name: 'roller door' },
    { name: 'tilta door' },
    { name: 'timber door' },
    { name: 'auto door opener' },
    { name: 'unlined' },
    { name: 'lined' },
    { name: 'partially lined' },
    { name: 'laundry facilities' },
    { name: 'power' },
    { name: 'workbench' },
    { name: 'storage cupboard' },
    { name: 'ranchslider to the exterior' },
    { name: 'external access to the exterior' },
    { name: 'carpet flooring' },
    { name: 'single door to the exterior' },
    { name: 'smoke detector' },
    { name: 'Other' },
  ],
  'AdditionalGarageNoOfCars': [
    { name: 'Single', parameter1: '1' },
    { name: 'Double', parameter1: '2' },
    { name: 'Triple', parameter1: '3' },
    { name: 'Tandem', parameter1: '2' },
  ],
  'AdditionalGarageType': [
    { name: 'Garage', parameter1: '1', parameter2: '1' },
    { name: 'Carport', parameter1: '1', parameter2: '1' },
    { name: 'Basement Garage', parameter1: '0', parameter2: '1' },
    { name: 'Off Street Parking', parameter1: '0', parameter2: '0' },
    { name: 'No off street parking', parameter1: '0', parameter2: '0' },
    { name: 'Uncovered carpark is provided', parameter1: '0', parameter2: '0' },
    { name: 'No covered parking provided', parameter1: '0', parameter2: '0' },
    { name: 'An implement shed', parameter1: '0', parameter2: '0' },
    { name: 'A workshop', parameter1: '0', parameter2: '0' },
    { name: 'A parking platform', parameter1: '0', parameter2: '0' },
  ],
  'BathroomFixtures': [
    { name: 'Single vanity' },
    { name: 'Double vanity' },
    { name: 'Wall hung single vanity' },
    { name: 'Wall hung double vanity' },
    { name: 'Hand basin' },
    { name: 'Pedestal hand basin' },
    { name: 'shower' },
    { name: 'tiled shower' },
    { name: 'level entry shower' },
    { name: 'built in bath' },
    { name: 'built in bath with overhead shower' },
    { name: 'spa bath' },
    { name: 'free standing bath' },
    { name: 'toilet' },
    { name: 'bidet' },
    { name: 'heated towel rail' },
    { name: 'wall mirror' },
    { name: 'medicine cabinet' },
    { name: 'extractor fan' },
    { name: 'heat lamp/extractor fan' },
    { name: 'wall heater' },
    { name: 'wall tiles' },
    { name: 'tiles to dado height' },
    { name: 'includes laundry facilities' },
    { name: 'wash tray' },
    { name: 'urinal' },
    { name: 'stainless steel urinal' },
    { name: 'wall hung urinal' },
    { name: 'Other' },
  ],
  'BathroomFloorCoverings': [
    { name: 'tiled floor with underfloor heating' },
    { name: 'vinyl flooring' },
    { name: 'tiled floor' },
    { name: 'polished floor' },
    { name: 'overlay flooring' },
    { name: 'vinyl plank flooring' },
    { name: 'timber flooring' },
    { name: 'concrete flooring' },
    { name: 'particleboard flooring' },
  ],
  'BathroomVanityUnitTops': [
    { name: 'Double vanity' },
    { name: 'Hand basin' },
    { name: 'Pedestal hand basin' },
    { name: 'Single vanity' },
    { name: 'Wall hung double vanity' },
    { name: 'Wall hung single vanity' },
  ],
  'BedroomFixtures': [
    { name: 'Single size' },
    { name: 'Double size' },
    { name: 'Twin size' },
    { name: 'wardrobe' },
    { name: 'single wardrobe' },
    { name: 'double wardrobe' },
    { name: 'walk in wardrobe' },
    { name: 'no wardrobe' },
    { name: 'a separate office alcove' },
    { name: 'heat pump' },
    { name: 'ceiling fan' },
    { name: 'fireplace' },
    { name: 'freestanding fireplace' },
    { name: 'wall heater' },
    { name: 'built in cabinetry' },
    { name: 'ranchslider to the exterior' },
    { name: 'bi-folding doors to the exterior' },
    { name: 'sliding door to the exterior' },
    { name: 'stacking doors to the exterior' },
    { name: 'French doors to the exterior' },
    { name: 'ensuite' },
    { name: 'smoke detector' },
    { name: 'Other' },
  ],
  'BedroomFloorCovering': [
    { name: 'carpet flooring' },
    { name: 'polished floor' },
    { name: 'tiled floor' },
    { name: 'vinyl flooring' },
    { name: 'overlay flooring' },
    { name: 'vinyl plank flooring' },
    { name: 'concrete flooring' },
    { name: 'timber flooring' },
    { name: 'particleboard flooring' },
  ],
  'Benchtops': [
    { name: 'Formica' },
    { name: 'Laminate' },
    { name: 'Engineered stone' },
    { name: 'Granite' },
    { name: 'Stainless steel' },
    { name: 'Timber' },
    { name: 'Stainless steel sinkbench' },
  ],
  'ChattelsCondition': [
    { name: 'As new' },
    { name: 'Excellent' },
    { name: 'Near new' },
    { name: 'Good' },
    { name: 'Satisfactory' },
    { name: 'Mixed' },
    { name: 'Dated' },
    { name: 'Worn' },
  ],
  'ChattelsQuality': [
    { name: 'Excellent' },
    { name: 'Good' },
    { name: 'Above average' },
    { name: 'Average' },
    { name: 'Basic' },
  ],
  'ChattelsSelection': [
    { name: 'alarm system' },
    { name: 'carpets' },
    { name: 'blinds' },
    { name: 'drapes' },
    { name: 'dishwasher' },
    { name: 'waste disposal' },
    { name: 'plumbed in fridge/freezer' },
    { name: 'light fittings' },
    { name: 'ceiling fan' },
    { name: 'extractor fans' },
    { name: 'heated towel rails' },
    { name: 'air ventilation system' },
    { name: 'central vacuum system' },
    { name: 'garage door opener' },
    { name: 'spa pool' },
    { name: 'swimming pool pump' },
    { name: 'water pump' },
    { name: 'sewer pump' },
    { name: 'irrigation system' },
    { name: 'window and floor coverings' },
    { name: 'heat pump' },
    { name: 'heat recovery ventilation' },
    { name: 'heat transfer units' },
    { name: 'solar panels' },
    { name: 'Other' },
  ],
  'Condition': [
    { name: 'Excellent' },
    { name: 'Above Average' },
    { name: 'Good' },
    { name: 'Satisfactory' },
    { name: 'Below Average' },
    { name: 'Poor' },
    { name: 'TBE - assumed good on completion' },
    { name: 'TBE – assumed good with further establishment works required ' },
  ],
  'Count': [
    { name: '1' },
    { name: '2' },
    { name: '3' },
    { name: '4' },
  ],
  'Cupboards': [
    { name: 'melteca' },
    { name: 'timber' },
    { name: 'lacquer' },
    { name: 'laminate' },
    { name: 'overhead' },
    { name: 'soft close fittings' },
  ],
  'DiningFixture': [
    { name: 'Separate dining room' },
    { name: 'Open plan with the kitchen and lounge' },
    { name: 'Open plan with the kitchen and living' },
    { name: 'Open plan with kitchen and family' },
    { name: 'Open plan with lounge' },
    { name: 'Open plan with family' },
    { name: 'Open plan with kitchen' },
    { name: 'Incorporated within the kitchen' },
    { name: 'Open plan' },
    { name: 'formal' },
    { name: 'freestanding fireplace' },
    { name: 'gas fireplace' },
    { name: 'heat pump' },
    { name: 'wall heater' },
    { name: 'built in cabinetry' },
    { name: 'ranchslider to the exterior' },
    { name: 'bi-folding doors to the exterior' },
    { name: 'door to exterior' },
    { name: 'French doors to the exterior' },
    { name: 'Other' },
  ],
  'DiningFloorCovering': [
    { name: 'carpet flooring' },
    { name: 'polished floor' },
    { name: 'tiled floor' },
    { name: 'vinyl flooring' },
    { name: 'overlay flooring' },
    { name: 'vinyl plank flooring' },
    { name: 'timber flooring' },
    { name: 'concrete flooring' },
    { name: 'particleboard flooring' },
  ],
  'Ensuite': [
    { name: 'Ensuite' },
  ],
  'EntryFixture': [
    { name: 'A formal entry' },
    { name: 'An informal entry', parameter1: '1', parameter2: '0' },
    { name: 'Directly into the hallway' },
    { name: 'Directly into the living area' },
    { name: 'Directly into the laundry' },
    { name: 'A formal entrance porch and foyer' },
    { name: 'A recessed entry with verandah cover' },
    { name: 'stairs to first floor' },
    { name: 'storage cupboard' },
    { name: 'recessed display' },
    { name: 'feature lighting' },
    { name: 'double front doors' },
    { name: 'Other' },
  ],
  'EntryFloorCovering': [
    { name: 'carpet flooring' },
    { name: 'polished floor' },
    { name: 'tiled floor' },
    { name: 'vinyl flooring' },
    { name: 'overlay flooring' },
    { name: 'vinyl plank flooring' },
    { name: 'timber flooring' },
    { name: 'concrete flooring' },
    { name: 'particleboard flooring' },
  ],
  'FamilyFixture': [
    { name: 'Open plan with the dining area and kitchen' },
    { name: 'Open plan with the dining area' },
    { name: 'Open plan with the kitchen' },
    { name: 'Open plan' },
    { name: 'Separate living area' },
    { name: 'gas fireplace' },
    { name: 'gas heater' },
    { name: 'built in fireplace' },
    { name: 'open fireplace' },
    { name: 'freestanding fireplace' },
    { name: 'heat pump' },
    { name: 'wall heater' },
    { name: 'ceiling fan' },
    { name: 'sarked ceiling' },
    { name: 'raked ceiling' },
    { name: 'ranchslider to the exterior' },
    { name: 'bi-folding doors to the exterior' },
    { name: 'stacking doors to the exterior' },
    { name: 'sliding door to the exterior' },
    { name: 'door to exterior' },
    { name: 'French doors to the exterior' },
    { name: 'smoke detector' },
    { name: 'Other' },
  ],
  'FamilyFloorCovering': [
    { name: 'carpet flooring' },
    { name: 'polished floor' },
    { name: 'tiled floor' },
    { name: 'vinyl flooring' },
    { name: 'overlay flooring' },
    { name: 'vinyl plank flooring' },
    { name: 'timber flooring' },
    { name: 'concrete flooring' },
    { name: 'particleboard flooring' },
  ],
  'FloorCoveringsKitchen': [
    { name: 'tiled floor with underfloor heating' },
    { name: 'vinyl flooring' },
    { name: 'polished floor' },
    { name: 'tiled floor' },
    { name: 'overlay flooring' },
    { name: 'vinyl plank flooring' },
    { name: 'timber flooring' },
    { name: 'particleboard flooring' },
    { name: 'concrete flooring' },
  ],
  'GarageConfiguration': [
    { name: 'Integrated' },
    { name: 'Detached' },
    { name: 'Attached' },
  ],
  'GarageFixturesAndFittings': [
    { name: 'internal access' },
    { name: 'insulated sectional door' },
    { name: 'sectional door' },
    { name: 'roller door' },
    { name: 'tilta door' },
    { name: 'timber door' },
    { name: 'auto door opener' },
    { name: 'unlined' },
    { name: 'lined' },
    { name: 'partially lined' },
    { name: 'laundry facilities' },
    { name: 'power' },
    { name: 'workbench' },
    { name: 'storage cupboard' },
    { name: 'ranchslider to the exterior' },
    { name: 'external access to the exterior' },
    { name: 'carpet flooring' },
    { name: 'single door to the exterior' },
    { name: 'smoke detector' },
    { name: 'Other' },
  ],
  'GarageNoOfCars': [
    { name: 'Single', parameter1: '1' },
    { name: 'Double', parameter1: '2' },
    { name: 'Triple', parameter1: '3' },
    { name: 'Tandem', parameter1: '2' },
  ],
  'GarageType': [
    { name: 'Garage', parameter1: '1', parameter2: '1' },
    { name: 'Carport', parameter1: '1', parameter2: '1' },
    { name: 'Basement Garage', parameter1: '0', parameter2: '1' },
    { name: 'Off Street Parking', parameter1: '0', parameter2: '0' },
    { name: 'No off street parking', parameter1: '0', parameter2: '0' },
    { name: 'Uncovered carpark is provided', parameter1: '0', parameter2: '0' },
    { name: 'No covered parking provided', parameter1: '0', parameter2: '0' },
    { name: 'An implement shed', parameter1: '0', parameter2: '0' },
    { name: 'A workshop', parameter1: '0', parameter2: '0' },
    { name: 'A parking platform', parameter1: '0', parameter2: '0' },
  ],
  'HallwayFixture': [
    { name: 'Central hallway' },
    { name: 'L-shaped hallway' },
    { name: 'Short passageway' },
    { name: 'provides access to most rooms' },
    { name: 'single linen cupboard' },
    { name: 'double linen cupboard' },
    { name: 'storage cupboard' },
    { name: 'hot water cylinder cupboard' },
    { name: 'stairs to first floor' },
    { name: 'stairs to basement' },
    { name: 'internal access to garage' },
    { name: 'gas heater' },
    { name: 'electric heater' },
    { name: 'heat pump' },
    { name: 'smoke detector' },
    { name: 'wall mounted circuit breaker' },
    { name: 'Other' },
  ],
  'HallwayFloorCovering': [
    { name: 'carpet flooring' },
    { name: 'polished floor' },
    { name: 'tiled floor' },
    { name: 'vinyl flooring' },
    { name: 'overlay flooring' },
    { name: 'vinyl plank flooring' },
    { name: 'timber flooring' },
    { name: 'concrete flooring' },
    { name: 'particleboard flooring' },
  ],
  'InternalFixtures': [
    { name: 'Air ventilation system' },
    { name: 'Air-conditioning' },
    { name: 'Alarm system' },
    { name: 'Central heating' },
    { name: 'Central vacuum system' },
    { name: 'Continuous gas hot water supply' },
    { name: 'Ducted air-conditioning' },
    { name: 'Ducted heat pump' },
    { name: 'Electric hot water system' },
    { name: 'Gas central heating' },
    { name: 'Heat pump' },
    { name: 'Home automation system' },
    { name: 'Inbuilt home audio system' },
    { name: 'LED lighting' },
    { name: 'Solar hot water system' },
    { name: 'Under floor heating' },
    { name: 'Wet back hot water system' },
    { name: 'Other' },
  ],
  'KitchenFixtures': [
    { name: 'centre island bench' },
    { name: 'servery' },
    { name: 'breakfast bar' },
    { name: 'single sink' },
    { name: 'double stainless steel sinks' },
    { name: 'stainless steel sink' },
    { name: 'waste disposal' },
    { name: 'garbage disposal' },
    { name: 'water filter' },
    { name: 'pantry' },
    { name: 'walk-in pantry' },
    { name: 'scullery' },
    { name: 'dishwasher' },
    { name: 'single dishdrawer' },
    { name: 'double dishdrawer' },
    { name: 'four plate electric stove' },
    { name: 'four plate gas stove' },
    { name: '900mm gas stove' },
    { name: 'electric hob' },
    { name: 'ceramic hob' },
    { name: 'induction hob' },
    { name: 'gas hob' },
    { name: 'under bench oven' },
    { name: 'wall oven' },
    { name: 'double wall oven' },
    { name: 'rangehood' },
    { name: 'extractor fan' },
    { name: 'splashback' },
    { name: 'hot water cylinder cupboard' },
    { name: 'Other' },
  ],
  'LaundryFixture': [
    { name: 'supertub with washing machine fittings' },
    { name: 'stainless steel tub' },
    { name: 'formica benchtop with sink' },
    { name: 'granite benchtop with sink' },
    { name: 'engineered stone benchtop with sink' },
    { name: 'concrete tub' },
    { name: 'under cabinet' },
    { name: 'hot water cylinder cupboard' },
    { name: 'built in cabinetry' },
    { name: 'internal access to the garage' },
    { name: 'exterior door' },
    { name: 'Other' },
  ],
  'LaundryFloor': [
    { name: 'tiled floor with underfloor heating' },
    { name: 'vinyl flooring' },
    { name: 'tiled floor' },
    { name: 'polished floor' },
    { name: 'overlay flooring' },
    { name: 'vinyl plank flooring' },
    { name: 'timber flooring' },
    { name: 'concrete flooring' },
    { name: 'particleboard flooring' },
    { name: 'carpet flooring' },
  ],
  'LaundryLocation': [
    { name: 'A separate room' },
    { name: 'Located in the garage' },
    { name: 'Incorporated in the kitchen' },
    { name: 'Incorporated in the bathroom' },
  ],
  'LivingFixture': [
    { name: 'Open plan dining room and kitchen area' },
    { name: 'Open plan with the dining room and kitchen' },
    { name: 'Open plan' },
    { name: 'Separate second living area' },
    { name: 'gas heater' },
    { name: 'solid fuel fire' },
    { name: 'natural flame gas fire' },
    { name: 'heatpump' },
    { name: 'enclosed fire' },
    { name: 'freestanding fireplace' },
    { name: 'no fixed heating installed' },
    { name: 'bi-folding doors to the exterior' },
    { name: 'ranchslider to the exterior' },
    { name: 'sliding door to the exterior' },
    { name: 'door to exterior' },
    { name: 'French doors to the exterior' },
    { name: 'smoke detector' },
    { name: 'stacking doors to the exterior' },
    { name: 'Other' },
  ],
  'LivingFloorCovering': [
    { name: 'carpet flooring' },
    { name: 'polished floor' },
    { name: 'tiled floor' },
    { name: 'vinyl flooring' },
    { name: 'overlay flooring' },
    { name: 'vinyl plank flooring' },
    { name: 'timber flooring' },
    { name: 'concrete flooring' },
    { name: 'particleboard flooring' },
  ],
  'LoungeFixtures': [
    { name: 'Open plan with the dining area and kitchen' },
    { name: 'Open plan with the dining area' },
    { name: 'Open plan with the kitchen' },
    { name: 'Open plan' },
    { name: 'Separate living area' },
    { name: 'gas fireplace' },
    { name: 'gas heater' },
    { name: 'built in fireplace' },
    { name: 'freestanding fireplace' },
    { name: 'open fireplace' },
    { name: 'heat pump' },
    { name: 'wall heater' },
    { name: 'ceiling fan' },
    { name: 'sarked ceiling' },
    { name: 'raked ceiling' },
    { name: 'ranchslider to the exterior' },
    { name: 'bi-folding doors to the exterior' },
    { name: 'stacking doors to the exterior' },
    { name: 'sliding door to the exterior' },
    { name: 'door to exterior' },
    { name: 'French doors to the exterior' },
    { name: 'smoke detector' },
    { name: 'Other' },
  ],
  'LoungeFloorCovering': [
    { name: 'carpet flooring' },
    { name: 'polished floor' },
    { name: 'tiled floor' },
    { name: 'vinyl flooring' },
    { name: 'overlay flooring' },
    { name: 'vinyl plank flooring' },
    { name: 'timber flooring' },
    { name: 'concrete flooring' },
    { name: 'particleboard flooring' },
  ],
  'MealsFixture': [
    { name: 'Separate dining room' },
    { name: 'Open plan with the kitchen and lounge' },
    { name: 'Open plan with the kitchen and living' },
    { name: 'Open plan with kitchen and family' },
    { name: 'Open plan with lounge' },
    { name: 'Open plan with family' },
    { name: 'Open plan with kitchen' },
    { name: 'Incorporated within the kitchen' },
    { name: 'formal' },
    { name: 'freestanding fireplace' },
    { name: 'gas fireplace' },
    { name: 'heat pump' },
    { name: 'wall heater' },
    { name: 'built in cabinetry' },
    { name: 'ranchslider to the exterior' },
    { name: 'bi-folding doors to the exterior' },
    { name: 'French doors to the exterior' },
    { name: 'Other' },
  ],
  'MealsFloorCovering': [
    { name: 'carpet flooring' },
    { name: 'polished floor' },
    { name: 'tiled floor' },
    { name: 'vinyl flooring' },
    { name: 'overlay flooring' },
    { name: 'vinyl plank flooring' },
    { name: 'timber flooring' },
    { name: 'concrete flooring' },
    { name: 'particleboard flooring' },
  ],
  'MediaFixture': [
    { name: 'Open plan with the dining area and kitchen' },
    { name: 'Open plan with the dining area' },
    { name: 'Open plan with the kitchen' },
    { name: 'Separate living area' },
    { name: 'gas fireplace' },
    { name: 'gas heater' },
    { name: 'built in fireplace' },
    { name: 'freestanding fireplace' },
    { name: 'open fireplace' },
    { name: 'heat pump' },
    { name: 'wall heater' },
    { name: 'ceiling fan' },
    { name: 'sarked ceiling' },
    { name: 'raked ceiling' },
    { name: 'ranchslider to the exterior' },
    { name: 'bi-folding doors to the exterior' },
    { name: 'stacking doors to the exterior' },
    { name: 'sliding door to the exterior' },
    { name: 'French doors to the exterior' },
    { name: 'smoke detector' },
    { name: 'Other' },
  ],
  'MediaFloorCovering': [
    { name: 'carpet flooring' },
    { name: 'polished floor' },
    { name: 'tiled floor' },
    { name: 'vinyl flooring' },
    { name: 'overlay flooring' },
    { name: 'vinyl plank flooring' },
    { name: 'timber flooring' },
    { name: 'concrete flooring' },
    { name: 'particleboard flooring' },
  ],
  'MoreRooms': [
    { name: 'Hallway' },
    { name: 'Study Nook' },
    { name: 'Sunroom' },
    { name: 'Theatre room' },
    { name: 'Activity room' },
    { name: 'Attached self contained residence' },
    { name: 'Billiard room' },
    { name: 'Enclosed verandah' },
    { name: 'Library' },
    { name: 'Multi-purpose room' },
    { name: 'Parents retreat' },
    { name: 'Sitting room' },
    { name: 'Storage area' },
    { name: 'Storage area to the lower level' },
    { name: 'Studio' },
    { name: 'Workshop area' },
    { name: 'Guest room' },
    { name: 'Sleepout' },
    { name: 'Office' },
    { name: 'Conservatory' },
  ],
  'OutdoorArea': [
    { name: 'Cabana' },
    { name: 'Courtyard' },
    { name: 'Alfresco area' },
    { name: 'Balcony' },
    { name: 'Deck' },
    { name: 'Multiple balconies' },
    { name: 'Pergola' },
    { name: 'Porch' },
    { name: 'Patio' },
    { name: 'Verandah' },
    { name: 'Other' },
  ],
  'PowderRoomFixtures': [
    { name: 'Separate toilet' },
    { name: 'hand basin' },
    { name: 'access to bathroom' },
    { name: 'access to laundry' },
    { name: 'dual access' },
    { name: 'vent' },
    { name: 'mirror' },
    { name: 'Other' },
  ],
  'PowderRoomFloorCovering': [
    { name: 'under floor heating' },
    { name: 'vinyl flooring' },
    { name: 'tiled floor' },
    { name: 'polished floor' },
    { name: 'overlay flooring' },
    { name: 'vinyl plank flooring' },
    { name: 'timber flooring' },
    { name: 'concrete flooring' },
    { name: 'particleboard flooring' },
  ],
  'RumpusFixture': [
    { name: 'An additional living area' },
    { name: 'gas heater' },
    { name: 'built in fireplace' },
    { name: 'freestanding fireplace' },
    { name: 'open fireplace' },
    { name: 'heat pump' },
    { name: 'ceiling fan' },
    { name: 'sarked ceiling' },
    { name: 'aked ceiling' },
    { name: 'ranchslider to the exterior' },
    { name: 'bi-folding doors to the exterior' },
    { name: 'French doors to the exterior' },
    { name: 'Other' },
  ],
  'RumpusFloorCovering': [
    { name: 'carpet flooring' },
    { name: 'polished floor' },
    { name: 'tiled floor' },
    { name: 'vinyl flooring' },
    { name: 'overlay flooring' },
    { name: 'vinyl plank flooring' },
    { name: 'timber flooring' },
    { name: 'concrete flooring' },
    { name: 'particleboard flooring' },
  ],
  'StudyFixture': [
    { name: 'A separate office' },
    { name: 'A separate office which could be utilised as a bedroom' },
    { name: 'storage cupboard' },
    { name: 'built in cabinetry' },
    { name: 'built in desk' },
    { name: 'heat pump' },
    { name: 'ceiling fan' },
    { name: 'ranchslider to the exterior' },
    { name: 'bi-folding doors to the exterior' },
    { name: 'French doors to the exterior' },
    { name: 'Other' },
  ],
  'StudyFloorCovering': [
    { name: 'carpet flooring' },
    { name: 'polished floor' },
    { name: 'tiled floor' },
    { name: 'vinyl flooring' },
    { name: 'overlay flooring' },
    { name: 'vinyl plank flooring' },
    { name: 'timber flooring' },
    { name: 'concrete flooring' },
    { name: 'particleboard flooring' },
  ],
  'Style': [
    { name: 'modern' },
    { name: 'semi-modern' },
    { name: 'dated' },
  ],
};
